<!------------------------------

    Table Wrapper

------------------------------->
<sb-table-wrapper
  (optionsChange)="requestDebounced($event)"
  [itemName]="'locations'"
  [itemsData]="locations" [loading]="loading"
  [options]="options" [showExactMatch]="true" [isInIntegratedContext]="true"
  headline="{{'lang.headlines.locations' | translate}}">

  <!------------------------------

     Header More

------------------------------->
  <div header-more>
    <sb-button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top" container="body"
               classes="btn-default actionButtonMinWidth"
               (click)="requestDebounced()" [disabled]="loading" [loading]="loading">
      <sb-icon icon="refresh"></sb-icon>
    </sb-button>
    <a [sbRouterLink]="util.RoutingID.locations" [queryParams]="{'companyIds': getCompanyId()}">
      <button class="btn btn-primary">{{'lang.globals.showInList' | translate}}</button>
    </a>
  </div>

  <!------------------------------

           Table Header

     ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{'lang.globals.status' | translate}}
      </th>
      <th>
        {{'lang.globals.devices' | translate}}
      </th>
      <th>
        {{'lang.globals.id' | translate}}
      </th>
      <th>
        {{'lang.globals.identifier' | translate}}
      </th>
      <th>
        {{'lang.globals.name' | translate}}
      </th>
      <th>
        {{'lang.address.address' | translate}}
      </th>
      <th class="tr">
        {{'lang.globals.actions'| translate}}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-location>
    <tr>
      <td>
        <p sb-comp-location-online-status [location]="location" class="mb-1">
        </p>
      </td>
      <td>
        <sb-icon class="mr-2" icon="screen"></sb-icon>
        {{location?.countDevices}}
      </td>
      <td>
        {{ location?.id }}
      </td>
      <td>
        {{ location?.identifier }}
      </td>
      <td>
        {{ location?.name }}
      </td>
      <td>
        <a *ngIf="location?.address?.position" class="link" ngbTooltip
           [sbMapTooltip]="{type: 'Coordinates', data: { x: location.address.position.coordinates[0], y: location.address.position.coordinates[1] }}"
           tooltipClass="widthFix" placement="right left" container="body" openDelay="300">
          <sb-icon icon="locationStreet" class="mr-2"></sb-icon>
          {{ stringTransformation.addressToString(location?.address) }}
        </a>
        <span *ngIf="!location?.address?.position">{{ stringTransformation.addressToString(location?.address) }}</span>
      </td>
      <td class="tr">
        <a *ngPermissions="permissionService.Permission.location_show" container="body"
           [sbRouterLink]="util.RoutingID.locationDetails" [pathParams]="[{id: 'locationID', value: location?.id }]"
           ngbTooltip="{{'lang.globals.openDetails' | translate}}" placement="left">
          <sb-button classes="btn-hover-primary">
            <sb-icon icon="details"></sb-icon>
          </sb-button>
        </a>
      </td>
    </tr>
  </ng-template>
</sb-table-wrapper>
